
import { useState, useEffect } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { getCourse } from "@/lib/courses";
import { useAuth } from "@/contexts/AuthContext";

export const useCheckout = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { user, profile, loading: authLoading } = useAuth();
  
  // States
  const [loading, setLoading] = useState(false);
  const [courseData, setCourseData] = useState<any>(null);
  const [courseLoading, setCourseLoading] = useState(true);
  const [courseError, setCourseError] = useState<string | null>(null);
  const [showAuthForm, setShowAuthForm] = useState(false);
  
  // Get course ID from URL
  const courseId = searchParams.get("courseId");
  
  // Fetch course data
  useEffect(() => {
    const fetchCourse = async () => {
      if (!courseId) {
        setCourseError("No course ID provided");
        setCourseLoading(false);
        return;
      }
      
      try {
        setCourseLoading(true);
        const course = await getCourse(courseId);
        if (!course) {
          setCourseError("Course not found");
        } else {
          setCourseData(course);
        }
      } catch (error) {
        console.error("Error fetching course:", error);
        setCourseError("Failed to load course details");
      } finally {
        setCourseLoading(false);
      }
    };
    
    fetchCourse();
  }, [courseId]);
  
  // User's full name - correctly get it from profile
  const userName = profile?.full_name || "";
  
  // Show login form if user is not authenticated
  const handleContinueToPayment = () => {
    if (!user) {
      setShowAuthForm(true);
    }
  };
  
  // Handle auth success
  const handleAuthSuccess = () => {
    setShowAuthForm(false);
  };

  return {
    courseId,
    courseData,
    courseLoading,
    courseError,
    user,
    authLoading,
    loading,
    setLoading,
    userName,
    showAuthForm,
    handleContinueToPayment,
    handleAuthSuccess
  };
};
